export const EXCEL_ADDIN_AUTH_PARAM = 'excelAddinAuth';

export const EXCEL_ADDIN_LOGOUT_PARAM = 'excelAddinLogout';

/**
 * Session-storage keys that keep the dialog recognisable across the Auth0 round trip. The query
 * parameter is gone by the time Auth0 redirects back, so the flag is what survives.
 */
export const EXCEL_ADDIN_AUTH_FLAG = 'nsExcelAddinAuthDialog';
export const EXCEL_ADDIN_LOGOUT_FLAG = 'nsExcelAddinLogoutDialog';

export const EXCEL_ADDIN_LOGOUT_STARTED_FLAG = 'nsExcelAddinLogoutStarted';

export const OFFICE_JS_URL = 'https://appsforoffice.microsoft.com/lib/1/hosted/office.js';
